import React from "react";
import { SectionContentProps } from "../../types";
import TeamGridCards from "./TeamGridCards";
import TeamHorizontalCards from "./TeamHorizontalCards";
import TeamCircularCards from "./TeamCircularCards";
import OvanTeam from "../../ovan/ovanteam/OvanTeam";

export default function TeamSection({ content, onContentChange, isSelected }: SectionContentProps) {
    const variant = content?.variant || "v1";

    if (variant === "ovan") {
        return <OvanTeam content={content} onContentChange={onContentChange} isSelected={isSelected} />;
    }

    if (variant === "v2" || variant === "horizontal") {
        return <TeamHorizontalCards content={content} isSelected={isSelected} />;
    }

    if (variant === "v3" || variant === "circular") {
        return <TeamCircularCards content={content} isSelected={isSelected} />;
    }

    // Default to grid cards (v1)
    return <TeamGridCards content={content} isSelected={isSelected} />;
}
